import api from './api';

export async function createRapidFireOrder(plan) {
  const planId = Number(plan?.id);
  const amount = Number(plan?.discounted_price);
  if (!Number.isInteger(planId) || planId <= 0 || !Number.isFinite(amount) || amount <= 0) {
    throw new Error('Select a valid rapid attempt plan.');
  }
  const response = await api.post('/subscription/generate-order', {
    order_type: 'purchase-rapid-fire-attempts',
    rapid_fire_price_id: planId,
    amount: String(amount),
    currency: 'INR',
  });
  const body = response?.data || {};
  if (body.error || body.code !== 200) {
    throw new Error(body.message || 'Unable to create rapid attempt order.');
  }
  const order = body.dataset?.data || {};
  if (!order.vk_order_id) throw new Error('The server did not return an order ID.');
  return order;
}
